import { FormattedMessage } from "react-intl";
const PagePermissions = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="ConfluencePricingPageTeam24.features.pagePermissions.content.body"
                    defaultMessage="Control who can view, edit and comment on your pages, so important information can stay restricted until you’re ready to share."
                />
            </p>
        </div>
    );
};
export default PagePermissions;
